/**
 * line-gradient expressions for the fallback route (pure).
 *
 * The fallback draws the hero route with MapLibre line layers. `line-gradient`
 * may only read ["line-progress"], so the head and tail become stops:
 *
 *   transparent │ far colour ─── near colour │ transparent
 *               t0 (tail)          t1 (head)
 *
 * far = the trail end, near = the head (core); both equal at rest.
 */
import type { ExpressionSpecification } from "maplibre-gl";

export const CLEAR = "rgba(0,0,0,0)";
const EPS = 1e-6;

export function progressGradient(t0: number, t1: number, far: string, near: string): ExpressionSpecification {
  const a = Math.max(0, Math.min(1, t0));
  const b = Math.max(0, Math.min(1, t1));
  if (!(b - a > EPS)) return ["step", ["line-progress"], CLEAR, 0.5, CLEAR];
  const inner: ExpressionSpecification = ["interpolate", ["linear"], ["line-progress"], a, far, b, near];
  const openStart = a <= EPS;
  const openEnd = b >= 1 - EPS;
  if (openStart && openEnd) return inner;
  if (openStart) return ["step", ["line-progress"], inner, b, CLEAR];
  if (openEnd) return ["step", ["line-progress"], CLEAR, a, inner];
  return ["step", ["line-progress"], CLEAR, a, inner, b, CLEAR];
}
